import React, { useEffect, useState, useCallback } from 'react';

/** Toggle de pantalla completa (mismo diseño del switch .sp-um__toggle). */
export function FullscreenToggle({ target }) {
   const [isFull, setIsFull] = useState(false);

   
   useEffect(() => {
      const onChange = () => setIsFull(Boolean(document.fullscreenElement));
      document.addEventListener('fullscreenchange', onChange);
      document.addEventListener('webkitfullscreenchange', onChange);
      return () => {
         document.removeEventListener('fullscreenchange', onChange);
         document.removeEventListener('webkitfullscreenchange', onChange);
      };
   }, []);

   const enter = useCallback((el) => {
      if (el.requestFullscreen) return el.requestFullscreen();
      if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen(); // Safari
      if (el.msRequestFullscreen) return el.msRequestFullscreen();          // IE/Edge viejo
   }, []);

   const exit = useCallback(() => {
      if (document.exitFullscreen) return document.exitFullscreen();
      if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
      if (document.msExitFullscreen) return document.msExitFullscreen();
   }, []);

   const toggle = useCallback((e) => {
      const wantFull = e?.target?.checked ?? !document.fullscreenElement;
      try {
         if (wantFull) {
            const el = (target && target.current) || document.documentElement;
            enter(el);
         } else {
            if (document.fullscreenElement) exit();
         }
      } catch (err) {
         console.log('Fullscreen no disponible:', err);
      }
   }, [target, enter, exit]);

   return (
      <label className="sp-um__toggle">
         <span>
            {isFull
               ? <><i className="uil uil-compress"></i> Pantalla completa</>
               : <><i className="uil uil-expand-arrows-alt"></i> Pantalla completa</>}
         </span>
         <input type="checkbox" checked={isFull} onChange={toggle} />
         <span className="sp-um__switch" aria-hidden="true"></span>
      </label>
   );
}

export default FullscreenToggle;